import React, {useEffect, useState} from 'react';

import {formatFileSize} from 'utils/common';
import CheckIcon from 'assets/svgs/actions/check.svg';
import {uploadFileToDocument} from 'utils/fetch';
import {getFileIcon} from 'utils/commonReact';

const SingleFile = ({
  file,
  basicUser,
  folderId,
  parentId,
  categoryType,
  onUpload,
}) => {
  const [status, setStatus] = useState('UPLOADING');
  const uploadFile = async () => {
    const savedFile = await uploadFileToDocument({
      file,
      authToken: basicUser.authToken,
      folderId: folderId || undefined,
      parentId,
      companyId: null,
      categoryType,
    });

    const newFile = await savedFile.json();
    setStatus('UPLOADED');
    onUpload(newFile.file);
  };

  useEffect(() => {
    if (file) {
      uploadFile(file);
    }
  }, [file]);
  return (
    <div className="d-flex border-bottom py-3 px-4">
      {getFileIcon(file)}
      <div className="d-flex flex-column w-100 ">
        <span className="mb-2">{file.name}</span>
        <span>{formatFileSize(file.size, 2)}</span>
      </div>
      {status === 'UPLOADED' ? (
        <img alt="test" src={CheckIcon} height={20} />
      ) : (
        <div className="progress-upload mx-4 w-100">
          <div
            style={{
              width: `${status === 'UPLOADING' ? 40 : 0}%`,
            }}
            className="progress-inner"
          ></div>
        </div>
      )}
    </div>
  );
};

export default SingleFile;
